var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ItemValidators } from "../../../item-validators";
import { AbstractTreatment } from "../treatment";
var PocketReduction = /** @class */ (function (_super) {
    __extends(PocketReduction, _super);
    function PocketReduction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PocketReduction.validate = function (item, odontogram, items) {
        // validate teeth selected
        if (!ItemValidators.hasTeethSelected(item)) {
            return false;
        }
        // validate not missing
        if (!ItemValidators.notMissingTeeth(item, odontogram)) {
            return false;
        }
        return true;
    };
    PocketReduction.apply = function (odontogram, item) {
        var resolvedConditions = ["recession"];
        odontogram
            .filter(function (tooth) { return item.teeth.indexOf(tooth.number) > -1; })
            .forEach(function (tooth) {
            var boneLossItems = tooth.diagnosis.filter(function (_item) {
                return _item.condition === "bone-loss" ||
                    _item.condition === "periodontitis";
            });
            if (boneLossItems.length > 0) {
                // has bone loss
                tooth.gengiva_normal = false;
                // move gengiva line
                tooth.diagnosis.push({
                    condition: "recession",
                    options: boneLossItems[0].options,
                });
            }
        });
        return odontogram;
    };
    PocketReduction.getIdentifier = function () {
        return "pocket-reduction";
    };
    return PocketReduction;
}(AbstractTreatment));
export { PocketReduction };



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/perio/pocket-reduction.ts.pre-build-optimizer.js